$(document).ready(function() {
  $(".question-answer").find(".answer").slideUp()
  
  $(".question").click(function(){
    if($(this).siblings().css("display") == "block"){
       $(".question").find("i").removeClass("fa-minus")
       $(".question").find("i").addClass("fa-plus")
      $(this).siblings().slideUp()
      $(this).find("i").removeClass("fa-minus")
      $(this).find("i").addClass("fa-plus")
       
      
    	  }
    else{
      $(".question").find("i").removeClass("fa-minus")
       $(".question").find("i").addClass("fa-plus")
      $(this).siblings().slideDown()
    $(this).parents().siblings().find(".answer").slideUp()
    $(this).find("i").removeClass("fa-plus")
      $(this).find("i").addClass("fa-minus")
      
    }
    
  
  })
});